import type { Lens } from '@hookform/lenses';
import { z } from 'zod/v4';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { IxcRegistrationV1EmploymentSelfEmployed } from '@interxfi/types';
import { AppTextInputWithLens } from '../../../../../../components/form/app-text-input';

export const selfEmployedFormSchema = z.object({
  kind: z.literal('selfEmployed'),
  value: z.object({
    institution: z.string().nonempty({ error: 'Institution is required' }),
    occupation: z.string().nonempty({ error: 'Occupation is required' }),
  }),
});

type SelfEmployedFormValues = z.infer<typeof selfEmployedFormSchema>;

export const defaultSelfEmployedFormValues: SelfEmployedFormValues = {
  kind: 'selfEmployed',
  value: {
    institution: '',
    occupation: '',
  },
};

export function getInitialFormValuesForSelfEmployed(data: IxcRegistrationV1EmploymentSelfEmployed | undefined): SelfEmployedFormValues {
  return {
    ...defaultSelfEmployedFormValues,
    value: {
      institution: data?.institution ?? '',
      occupation: data?.occupation ?? '',
    },
  };
}

export function formValuesToSelfEmployed(values: SelfEmployedFormValues): IxcRegistrationV1EmploymentSelfEmployed {
  return {
    institution: values.value.institution.trim(),
    occupation: values.value.occupation.trim(),
  };
}

interface EmploymentSelfEmployedFormProps {
  lens: Lens<SelfEmployedFormValues>;
}

export function EmploymentSelfEmployedForm({ lens }: EmploymentSelfEmployedFormProps) {
  return (
    <VerticalStack gap={4}>
      <AppTextInputWithLens label="Occupation" lens={lens.focus('value.occupation')} required />
      <AppTextInputWithLens label="Institution" lens={lens.focus('value.institution')} required />
    </VerticalStack>
  );
}
